'use client'

import { ProjectPage } from '@/utilities/get-page'
import { createContext, useContext } from 'react'

export const AppContext = createContext<ProjectPage | undefined>(undefined)
export const useApp = () => useContext(AppContext) as ProjectPage

export default function AppProvider({
    children,
    projectPage
}: {
    children: any
    projectPage: ProjectPage
}) {
    return (
        <AppContext.Provider value={projectPage}>
            {children}
        </AppContext.Provider>
    )
}
